import * as type from "../../types/API/bomProductionProcess";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const createBOMProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.CREATE_BOM_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.CREATE_BOM_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.CREATE_BOM_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getBOMProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_BOM_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateBOMProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.UPDATE_BOM_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_BOM_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.UPDATE_BOM_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMProductionProcessReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_BOM_PRODUCTION_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_BOM_PRODUCTION_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_PRODUCTION_PROCESS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
